import useUpdateEffect from './useUpdateEffect';
import {getBrandByUtagData,getCategoryByUtagData} from '../modules/googleAd/googleAdUtils';
import {VOLTRAN_ADVERTISEMENT_EVENT_NAME} from '../modules/googleAd/googleAdConstants';
import {DAVINCI_PAGE_TYPES} from '../modules/analytics/davinci/davinciConstants';

export const useAdvertisement = ({seoInfo,pageType}) => {
  useUpdateEffect(() => {
    handleGoogleAds();
  }, [seoInfo])


  const handleGoogleAds = () => {
    setTimeout(() => {
      const brandTarget = getBrandByUtagData() || '';
      const categoryTarget = pageType === DAVINCI_PAGE_TYPES.CATEGORY ? {kategori: getCategoryByUtagData() || ''} : {};

      window?.HbEventBus?.emit(VOLTRAN_ADVERTISEMENT_EVENT_NAME, {
        targeting: {
          ...categoryTarget,
          BrandFilter: brandTarget,
        },
      })
    }, 500);
  }
}
